// extracted by mini-css-extract-plugin
export default {"searchBar__container":"SearchBar_searchBar__container__ppl2e","bottom":"SearchBar_bottom__aaHC5"};